export interface WeatherRoutingNotification {
    imo: number,
    schedule_id: string,
    terminal_from: string,
    terminal_to: string,
    audit_logs: AuditLog[]
}

export interface AuditLog {
    id: number;
    imo: number;
    mst_status_id: number | null;
    mst_status_name: string;
    correlation_id?: string;
    metadata: string | null;
    notes: string | null;
    source: string;
    log: string;
    created_at: string;
    status: string;
    schedule_id?: string,
    terminal_from?: string,
    terminal_to?: string,
}

export enum AuditLogState {
    READ = "read",
    UNREAD = "unread"
}

export enum AuditLogStatus {
    PlANSUBMITTEDTOWNI = "PlanSubmittedToWni",
    PLANRECEIVEDONSHORE = "PlanReceivedOnShore",
    WRADVICESAFETYCHECKED = "WrAdviceSafetyChecked",
    WRADVICEREJECTED = "WrAdviseRejected",
    WRADVICEACCEPTED = "WrAdviseAccepted",
    WEBHOOKRECEIVEDFROMWNI="WebhookReceivedFromWni"
}

export enum WeatherRoutingNotificationEvents {
    FETCHALL = "fetch-all",
}